import { GenericCard } from './GenericCard';
import { Check } from '../Icons/Icons';
import React from 'react';
import './MissionCard.scss';
import type { UserMissionsListResponse } from '../../utils/PointsAPI';

export type Mission = UserMissionsListResponse;

const numberFormat = new Intl.NumberFormat();

export function MissionCard({ mission, onClickMission }: MissionCardProps) {
  return (
    <GenericCard
      className="mission"
      imageUrl={`/${mission.image}`}
      top={
        <div className="mission-info">
          <h3>{mission.title}</h3>
          <p className="mission-description">{mission.description}</p>
        </div>
      }
      bottom={
        <div className={`mission-rewards ${mission.type === 'primary' && 'mission-primary'}`}>
          {mission.type === 'weekly' && (
            <p>
              OmniGrow Reward <span>{numberFormat.format(mission.reward)}</span>
            </p>
          )}
          {mission.completed && mission.type === 'weekly' ? (
            <div className="mission-completed">
              <Check />
            </div>
          ) : (
            <button
              className={`btn-sm btn btn-primary mission-`}
              onClick={() => onClickMission(mission)}
            >
              BEGIN
            </button>
          )}
        </div>
      }
    />
  );
}

export type MissionCardProps = {
  onClickMission: (mission: Mission) => void;
  mission: Mission;
};
